import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Modal,
  Button,
  CircularProgress,
  Checkbox,
  Divider,
} from '@mui/material';
import GoBack from 'js/containers/GoBack.js';

//icones
import alert from 'styles/assets/Messages/Alert.png';
import establishment from 'styles/assets/Messages/Establishment.png';
import news from 'styles/assets/Messages/News.png';
import promotion from 'styles/assets/Messages/Promotion.png';
import triibomania from 'styles/assets/Messages/Triibomania.png';
import provider from 'styles/assets/Messages/Provider.png';
import tribomania from 'styles/assets/Messages/Tribomania.png';

import { getLastUserInfo } from 'js/library/utils/helpers';
import {
  convertToDateDefault,
  trackEventMatomoVisit,
  trackEventMatomo,
} from 'js/library/utils/helpers';
import getMessage from 'js/library/utils/API/getMessage';
import deleteMessage from 'js/library/utils/API/deleteMessage';
import markAsRead from 'js/library/utils/API/markAsRead';

export default function Inbox() {
  window['alert'] = alert;
  window['establishment'] = establishment;
  window['news'] = news;
  window['promotion'] = promotion;
  window['triibomania'] = triibomania;
  window['tribomania'] = tribomania;
  window['provider'] = provider;

  const userInfo = getLastUserInfo();

  let timeDebounce = null;

  useEffect(() => {
    document.title = 'Caixa de entrada';
    trackEventMatomoVisit('CaixaDeEntrada');
  }, []);

  const [messages, setMessages] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [messageSelected, setMessageSelected] = useState(null);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const isAnonymous = userInfo.triiboId.indexOf('@anonymous-triibo.com.br') > 0;
  const { t } = useTranslation();

  if (!isAnonymous && messages === null) {
    getMessage(userInfo.uId)
      .then((reply) => {
        setMessages(reply.result);
      })
      .catch(() => {
        setMessages([]);
      });
  }

  const openMessage = (item) => {
    //informando que a mensagem foi lida para o banco
    if (messages[item].lida === undefined) {
      markAsRead(userInfo.uId, messages[item].tableId, userInfo.triiboId);

      let messageAux = [...messages];
      messageAux[item].lida = new Date().getTime();
      setMessages(messageAux);
    }

    setOpenModal(true);
    setMessageSelected(messages[item]);
  };

  const selectMessages = (item) => (event) => {
    let selectedMessagesAux = [...selectedMessages];

    if (event.target.checked) {
      selectedMessagesAux.push(item);
    } else {
      selectedMessagesAux = selectedMessagesAux.filter(function (value) {
        return value !== item;
      });
    }

    setSelectedMessages(selectedMessagesAux);
  };

  const deleteMessages = async () => {
    //APAGAR MENSAGENS SELECIONADAS
    let auxMessages = [...messages];

    selectedMessages.map((item) => {
      return deleteMessage(userInfo.uId, item);
      //return auxMessages = messages.filter((message) => message.tableId !== item);
    });

    auxMessages = auxMessages.filter((el) => !selectedMessages.includes(el.tableId));

    setSelectedMessages([]);
    setMessages(auxMessages);
  };

  function scrollMatomo() {
    clearTimeout(timeDebounce);
    timeDebounce = setTimeout(() => {
      trackEventMatomo('SuasTriibos', 'scroll', 'lista', 'suas triibos');
    }, 400);
  }

  if (isAnonymous) {
    return <Navigate to="/" />;
  } else {
    return (
      <div>
        <GoBack />

        <Typography variant="h6" color="secondary" style={{ fontWeight: 'bolder' }}>
          {t('messages.messages')}
        </Typography>

        <Divider color="secondary" style={{ margin: '10px 0px' }} />

        <div
          style={{
            height: 'calc(100vh - 260px)',
            flexFlow: 'column nowrap',
            display: 'flex',
          }}
        >
          {messages === null ? (
            <div style={{ textAlign: 'center' }} className="loading-content">
              <CircularProgress />
            </div>
          ) : messages.length === 0 ? (
            <Typography variant="h6" style={{ padding: '30px', color: '#707070' }}>
              <span>{t('messages.you_dont_have_messages')}</span>
            </Typography>
          ) : (
            <List onScroll={() => scrollMatomo()} className="scrollable messagesScroll">
              {messages.map((item, i) => {
                const icon = [item.tipo];

                return (
                  <div key={item.tableId}>
                    <ListItem
                      style={{ cursor: 'pointer' }}
                      onClick={() => openMessage(i)}
                      alignItems="flex-start"
                    >
                      <ListItemAvatar>
                        <img
                          width="60%"
                          className="img-radius"
                          src={window[icon]}
                          alt="notificacoes"
                        />
                      </ListItemAvatar>

                      <div style={{ width: '60%' }}>
                        <ListItemText
                          key={item.key}
                          primary={
                            <Typography
                              style={
                                item.lida === undefined
                                  ? { fontWeight: 'bolder', color: '#707070' }
                                  : { color: '#707070' }
                              }
                              variant="subtitle2"
                            >
                              {item.titulo}
                            </Typography>
                          }
                          secondary={<span style={{ color: '#707070' }}>{item.mensagem}</span>}
                        />
                      </div>

                      <ListItemSecondaryAction style={{ color: '#707070' }}>
                        <Checkbox
                          value="checkedA"
                          inputProps={{ 'aria-label': 'Checkbox A' }}
                          onChange={selectMessages(item.tableId)}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </div>
                );
              })}
            </List>
          )}

          <div
            className="fixed-button-messages"
            style={{
              marginTop: 10,
              display: selectedMessages.length === 0 ? 'none' : 'block',
            }}
            onClick={() => deleteMessages()}
          >
            <Typography
              style={{ fontWeight: 'bolder', color: 'white', textAlign: 'center' }}
              variant="subtitle2"
            >
              {t('messages.delete_selected')}
            </Typography>
          </div>
        </div>

        {messageSelected !== null ? (
          <Modal onClose={() => setOpenModal(false)} open={openModal}>
            <Paper
              style={{
                position: 'absolute',
                padding: '10px',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
              }}
            >
              <Grid container>
                <Grid size={{ md: 2 }}>
                  <img
                    width="50%"
                    className="img-radius"
                    src={window[[messageSelected.tipo]]}
                    alt="notificacoes"
                  />
                </Grid>

                <Grid size={{ md: 10 }}>
                  <Typography style={{ fontWeight: 'bold' }} variant="subtitle2">
                    {messageSelected.titulo}
                  </Typography>
                  <Typography variant="subtitle2">
                    {convertToDateDefault(messageSelected.data)}
                  </Typography>
                </Grid>
              </Grid>

              <hr />

              <Typography variant="subtitle1">{messageSelected.mensagem}</Typography>

              <br />
              {messageSelected.url !== undefined ? (
                <Button
                  color="primary"
                  onClick={() => window.open(messageSelected.url, 'new')}
                  fullWidth={true}
                  style={{ textTransform: 'capitalize' }}
                  className="delete-button"
                  variant="contained"
                >
                  <span style={{ fontWeight: '550', color: 'white' }}>
                    {t('messages.show_details')}
                  </span>
                </Button>
              ) : null}
            </Paper>
          </Modal>
        ) : null}
      </div>
    );
  }
}
